import ReactApexChart from "react-apexcharts";

const CandlestickChart = ({ series , stock , period }) => {
  const options = {
    chart: {
      type: "candlestick",
      height: 300,
      background: "#fdfdfd",
      toolbar: {
        show: true,
      },
    },
    title: {
      text: `${stock} - ${period} Candlestick Chart`,
      align: "left",
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div>
      <ReactApexChart options={options} series={series} type="candlestick" height={400} />
    </div>
  );
};

export default CandlestickChart;
